import {
	ChangeDetectionStrategy,
	Component,
	computed,
	input,
	signal,
} from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import {
	numberToPercentage,
	percentageToValue,
} from '@marmon/shared/types/common';
import { TuiHint } from '@taiga-ui/core';
import { MarmonIconType } from '../../icon/icons.const';
import {
	AnalysisCardComponent,
	AnalysisCardType,
} from '../analysis-card/analysis-card.component';

export type BarDistributionData = {
	value: number;
	percent: string;
	total: number;
};

type BarDistribution = {
	label: string;
	data: BarDistributionData[];
};

@Component({
	standalone: true,
	imports: [AnalysisCardComponent, TuiHint, TranslocoPipe],
	selector: 'mar-bar-distribution-card',
	templateUrl: 'bar-distribution-card.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: { class: 'contents' },
})
export class BarDistributionCardComponent {
	readonly icon = input.required<MarmonIconType>();
	readonly label = input.required<string>();
	readonly inputData = input.required<number[]>();
	readonly types = input<AnalysisCardType[]>(['percent', 'sum']);
	readonly legend = input<string[]>([]);

	readonly type = signal<AnalysisCardType>('percent');
	readonly colorIndex = [
		'border-green-600 bg-green-100',
		'border-red-600 bg-red-100',
	] as const;

	readonly displayData = computed<BarDistribution[]>(() => {
		const data = this.inputData();
		const total = data.reduce((a, c) => a + c, 0);

		const getData = (value: number) => ({
			percent: percentageToValue(value / total),
			value,
			total,
		});

		return [
			{ label: 'analysis.actual', data: data.map((d) => getData(d)) },
			{
				label: 'analysis.target',
				data: [
					getData(numberToPercentage(total * 0.2)),
					getData(numberToPercentage(total * 0.8)),
				],
			},
		];
	});

	onTypeChange(event: AnalysisCardType | undefined) {
		if (!event) return;
		this.type.set(event);
	}
}
